
export const dark = {
  color: {
    primary: 'white',
    secondary: 'white',
    bright: 'black',
    gray: 'gray',
  },
  backgroundColor: {
    primary: '#17191a',
    secondary: '#232526',
    bright: 'white',
  },
  borderColor: {
    primary: '#383a3b',
    secondary: '#999a9b',
    bright: '#383a3b',
  },
  button: {
    basic: {
      color: 'white',
      backgroundColor: '#1877f2',
      border: '1px solid #1877f2',
      borderRadius: '5px',
      padding: '10px',
      hover: {
        backgroundColor: '#77a7ff',
      },
    },
    accept: {
      border: '1px solid #00a400',
      color: 'white',
      backgroundColor: '#00a400',
      hover: {
        backgroundColor: '#007600',
      }
    },
    reject: {
      border: '1px solid #d42f2e',
      color: '#d42f2e',
      backgroundColor: 'white',
      hover: {
        backgroundColor: '#fddede',
      }
    },
  },
  link: {
    color: {
      primary: {
        default: 'white',
        hover: 'wheat',
      },
      secondary: {
        default: 'white',
        hover: 'wheat',
      },
      bright: {
        default: 'black',
        hover: 'blue',
      },
    }
  },
}

export const light = {
  color: {
    primary: 'black',
    secondary: '#4f5153',
    bright: '#8dd4ec',
    gray: 'gray',
  },
  backgroundColor: {
    primary: 'white',
    secondary: '#232526',
    bright: 'white',
  },
  borderColor: {
    primary: '#383a3b',
    secondary: '#999a9b',
    bright: '#383a3b',
  },
  button: {
    basic: {
      color: 'white',
      backgroundColor: '#1877f2',
      border: '1px solid #1877f2',
      borderRadius: '5px',
      padding: '10px',
      hover: {
        backgroundColor: '#77a7ff',
      },
    },
    accept: {
      border: '1px solid #00a400',
      color: 'white',
      backgroundColor: '#00a400',
      hover: {
        backgroundColor: '#007600',
      }
    },
    reject: {
      border: '1px solid #d42f2e',
      color: '#d42f2e',
      backgroundColor: 'white',
      hover: {
        backgroundColor: '#fddede',
      }
    },
  },
  link: {
    color: {
      primary: {
        default: 'white',
        hover: 'wheat',
      },
      secondary: {
        default: 'white',
        hover: 'wheat',
      },
      bright: {
        default: 'black',
        hover: 'blue',
      },
    }
  },
};

const themes = {
  dark,
  light,
  default: dark
};

const getTheme = theme => themes[theme] ?? themes.default;

export default getTheme;